import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RepeatOutlinedIcon from "@mui/icons-material/RepeatOutlined";

interface ExpenseActionDialogProps {
  open: boolean;
  onClose: () => void;
  onOneTimePress: () => void;
  onRecurringPress: () => void;
  t: (key: string, values?: Record<string, string | number>) => string;
}

const ExpenseActionDialog = ({
  open,
  onClose,
  onOneTimePress,
  onRecurringPress,
  t,
}: ExpenseActionDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 950 }}>
        {t("expenses.addExpense")}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={1.5}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onOneTimePress}
            sx={{ justifyContent: "flex-start", py: 1.4 }}
          >
            <Stack sx={{ alignItems: "flex-start" }}>
              <Typography sx={{ fontWeight: 900 }}>
                {t("expenses.oneTimeExpense")}
              </Typography>
              <Typography sx={{ fontSize: 13, opacity: 0.8 }}>
                {t("expenses.oneTimeExpenseDescription")}
              </Typography>
            </Stack>
          </Button>

          <Button
            fullWidth
            variant="outlined"
            startIcon={<RepeatOutlinedIcon />}
            onClick={onRecurringPress}
            sx={{ justifyContent: "flex-start", py: 1.4 }}
          >
            <Stack sx={{ alignItems: "flex-start" }}>
              <Typography sx={{ fontWeight: 900 }}>
                {t("expenses.recurringExpense")}
              </Typography>
              <Typography sx={{ fontSize: 13, opacity: 0.8 }}>
                {t("expenses.recurringExpenseDescription")}
              </Typography>
            </Stack>
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ExpenseActionDialog;
